export enum AppEnvironment {
  Production = "production",
  Staging = "staging",
  Development = "development",
}

const APP_ENVIRONMENT_VALUES = new Set<string>(Object.values(AppEnvironment))

function isAppEnvironment(value: string | undefined): value is AppEnvironment {
  return value !== undefined && APP_ENVIRONMENT_VALUES.has(value)
}

export function getAppEnvironment(
  value: string | undefined,
): AppEnvironment | null {
  return isAppEnvironment(value) ? value : null
}
